<template>
    <div class="d-flex justify-end">
        <div>
            <div class="social-networks">
                <div class="mt-4">
                    <footer-text text="РАИИ В СОЦИАЛЬНЫХ СЕТЯХ"/>
                </div>
                <div class="mt-6">
                    <footer-social-networks-links/>
                </div>
            </div>
            <div class="footer-social-networks-btn-metrika">
                <btn-metrika/>
            </div>
        </div>    
    </div>
</template>
<script>

import FooterText from '@/components/footer/FooterText.vue';
import FooterSocialNetworksLinks from '@/components/footer/FooterSocialNetworksLinks.vue'
import BtnMetrika from './BtnMetrika.vue';
export default{
    name: 'FooterSocialNetwork',
    components: {
        FooterText,
        FooterSocialNetworksLinks,
        BtnMetrika
    }
}
</script>
